import { Component, Output, EventEmitter, Input } from '@angular/core';
 import { CertificateService } from 'src/app/features/proof-of-life/services/certificate-auth/certificate.service';

@Component({
    selector: 'dp-button-certificate',
    templateUrl: './button-certificate.component.html',
    styleUrls: ['./button-certificate.component.scss']
})
export class ButtonCertificateComponent {
    @Output() public onerror = new EventEmitter();
    @Output() public onsuccess = new EventEmitter();
    @Input() public text = 'Clique aqui';
    @Input() public btnClass = '';

    public loading = false;
    public invalid = false;

    constructor(private certificateService: CertificateService) {}

    public validateCertificate(event: MouseEvent) {
        event.preventDefault();

        this.loading = true;

        this.certificateService.authenticate().subscribe(
            (response: any) => {
                this.onsuccess.emit();
                window.open(response.url, '_self');
            },
            () => {
                this.loading = false;
                this.invalid = true;

                setTimeout(() => {
                    this.invalid = false;
                }, 2000);
                this.onerror.emit();
            }
        );
    }
}
